import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import axios from "axios";
import {
	NoDataIndication,
	Loader,
	tableStyle,
	mystyle,
	dateCol,
} from "../../ticketModule/variables/ListingVariables";
import { Department_APIs } from "./Department_APIs";
import { UserConsumer } from "../../../UserContext";
import { goBackFunction } from "../../../utils";
import { Redirect } from "react-router-dom";
import FormStatus from "../../../components/FormStatus";
import { Routes } from "../../../configurations/config";
let token = null;
const departmentIds = ["3", "4", "5", "6", "9"]; // departmnts to which tickets can be assigned

class TicketHistory extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			formStatus: "",
			projectId: "",
			allocateTo: [],
			projectDetails: {},
			error: null,
			isLoaded: false,
			tableLoader: false,
			projectName: "",
			items: [],
			toggledClearRows: false,
			uniqueId: 1,
			columns: [
				{
					dataField: "status",
					text: "Satus",
					sort: true,
				},
				{
					dataField: "assignedTo",
					text: "Forwarded To",
					sort: true,
				},
				{
					dataField: "comments",
					text: "Department Comments",
					sort: true,
					headerStyle: {
						width: "25%",
					},
					formatter: (cell, row) => {
						return row.comments === "" || row.comments === null
							? "N/A"
							: row.comments;
					},
				},
				{
					dataField: "assignedBy",
					text: "Changed By",
					sort: true,
				},
				{
					dataField: "assignedOn",
					text: "Modified Date and Time",
					formatter: dateCol,
					sort: true,
				},
			],
		};
	}
	goBack = () => {
		goBackFunction(Routes.ProjectListing, this.props.history);
	};
	componentDidMount() {
		var headers = {
			Authorization: `Bearer ${token}`,
		};
		this.setState({ tableLoader: true }, () => {
			axios
				.get(
					`${Department_APIs.GetDepartmentHistory}${this.props.match.params.projectId}`,
					{
						headers: headers,
					}
				)
				.then((res) => {
					this.setState({
						items: res.data.ticketHistory,
						formStatus: res.data?.ticketHistory[0]?.currentStatus,
						tableLoader: !this.state.tableLoader,
					});
				});
		});
	}

	expandRow = {
		showExpandColumn: true,
		expandByColumnOnly: true,
		onlyOneExpanding: true,
		className: "expandingRow",
		renderer: (cell, row) => (
			<div>
				<label htmlFor="p1" style={mystyle}>
					Satus
				</label>
				<p id="p1">{cell.status}</p>
				<label htmlFor="p2" style={mystyle}>
					Forwarded To
				</label>
				<p id="p2">{cell.assignedTo ? cell.assignedTo : "N/A"}</p>
				<label for="p3" style={mystyle}>
					Department Comments
				</label>
				<p id="p3">{cell.comments ? cell.comments : "N/A"}</p>
				<label for="p4" style={mystyle}>
					Changed By
				</label>
				<p id="p4">{cell.assignedBy}</p>
				<label for="p5" style={mystyle}>
					Modified Date and Time
				</label>
				<p id="p5">
					{cell.assignedOn ? dateCol(cell.assignedOn) : "N/A"}
				</p>
			</div>
		),
	};
	defaultSorted = [
		{
			dataField: "assignedOn",
			order: "desc",
		},
	];
	render() {
		return (
			<UserConsumer>
				{(userDetails) => {
					token = userDetails.token;

					return userDetails.id.toString() === "79" || //kashif
						userDetails.id.toString() === "40" || //usmza
						userDetails.id.toString() === "33" || // Asif malik
						userDetails.id.toString() === "51" || //jibran
						userDetails.designation.toString() === "4" || //CM Role
						userDetails.empRole.includes("5") ||
						departmentIds.includes(
							userDetails.department.toString()
						) ||
						userDetails.empRole.includes("3") ? (
						<ToolkitProvider
							keyField="id"
							bootstrap4
							data={this.state.items}
							columns={this.state.columns}
							search
						>
							{(props) => (
								<div className="container-fluid pl-4 pr-4">
									<FormStatus
										title={
											this.props.history.location
												? this.props.history.location
														.state.projectName
												: "Ticket History"
										}
										formStatus={this.state.formStatus}
										className="create-request d-flex align-items-center"
										onClick={this.goBack}
										navigateBack={true}
									/>

									<BootstrapTable
										classes="table-sm table-borderless  table-responsive-md table-responsive-lg table-responsive-sm table-responsive-xl "
										rowStyle={tableStyle}
										headerClasses="header-class"
										expandRow={this.expandRow}
										bordered={false}
										{...props.baseProps}
										//pagination={paginationFactory(options)}
										hover={true}
										defaultSorted={this.defaultSorted}
										noDataIndication={() => (
											<NoDataIndication />
										)}
									/>
								</div>
							)}
						</ToolkitProvider>
					) : (
						<Redirect to="/MyDashboard" />
					);
				}}
			</UserConsumer>
		);
	}
}
export default TicketHistory;
